import * as React from 'react';

import {List} from '@common/typescript/objects/List';

import Musthead from '@app/components/UI/MustHead/Musthead';
import FaqBlock from '@app/components/UI/FaqBlock/FaqBlock';
import VideoEmbedSlider from '@app/components/UI/VideoEmbed/VideoEmbedSlider';

import {Questions} from '@app/objects/Questions';

import {rest} from '@app/components/Api';
import FaqBlockHeaderSm from '@app/components/UI/FaqBlock/FaqBlockHeaderSm';
import JobInquiryModal from '@app/components/UI/JobInquryModal/JobInquiryModal';
import FiftyFifty from '@app/components/UI/FiftyFifty/FiftyFifty';
import VeterinarianMapBlock from '@app/components/Pages/AboutUs/Careers/VeterinarianMapBlock';
import withSeo from '@app/components/LocalCommon/HigherOrderComponents/WithSeo';

const Veterinarian = () => {
	const mustHeadText = 'Turn your passion for pets into a career and help pet families navigate one of the hardest times of their lives.';

	const videoSrc = [
		'https://www.youtube.com/embed/zWHPAZOiHBY?showinfo=0',
		'https://www.youtube.com/embed/2UrHg9PdZQM?showinfo=0',
		'https://www.youtube.com/embed/2ubkxI0tsiI?showinfo=0'
	];

	const openInNewTab = (arg) => {
		const win = window.open(arg, '_blank');
		win && win.focus();
	};

	const videoText = <>
		<h4 className="rich-text__title">
			What calls us to do this work?
		</h4>
		<p>
			Lap of Love veterinarians are there for pet parents during one of the toughest moments of their lives.
			Beyond a natural love for caring for animals, our veterinarians have a genuine concern for the emotional
			well-being of people, which helps them provide such amazing end-of-life care.
		</p>
	</>;

	const veterinarianBlockText = 'Some of us just get it. We understand the value and fulfillment that comes with helping pets and the people who love them through the end-of-life process. As a doctor with our team, you will be at the forefront of this movement. You will be the “expert” other doctors refer to, the one friends and family reach out to when they are in need, and one of the leaders of this emerging field of veterinary medicine. We will give you all the tools you need to feel supported, encouraged, and educated. From resources and education opportunities to mentors and advisors, we succeed as a group, together.';

	const videoTitle = 'A few veterinarians share their love for the job.';

	const [questions, setQuestions] = React.useState<Questions[]>([]);
	const [modalVisible, setModalVisible] = React.useState(false);

	const externalResourceLink = 'https://form.jotform.com/210624784496161';

	const openModal = () => {
		setModalVisible(true);
	};

	React.useEffect(() => {
		rest.get<List<Questions>>('v1/faq/veterinarianPage').then(res => setQuestions(res.list));
		const mql = window.matchMedia('screen and (max-width: 768px)');
	}, []);
	return (
		<div className="care-coordinator become-veterinarian">
			<Musthead
				title="Become a Lap of Love Veterinarian"
				imageSrc={require('@app/content/Miranda-Shaw.jpg')}
				text={mustHeadText}
				buttonText="Apply now"
				btnPath={externalResourceLink}
				onBtnClick={openInNewTab}
				imageAlt="Veterinarian jobs"
			/>
			<FiftyFifty
				title="What it’s like being a Lap of Love veterinarian"
				text={veterinarianBlockText}
				reversed={true}
				src={require('@app/content/VeterinarianBlockImg.png')}
				alt="Veterinarian positions"
			/>

			<VeterinarianMapBlock link={externalResourceLink}/>
			<VideoEmbedSlider
				videoText={videoText}
				videoSrc={videoSrc}
				videoTitle={videoTitle}
			/>
			<div className="care-coordinator__faq">
				<div className="care-coordinator__faq-content">
					<FaqBlockHeaderSm
						title="You might find yourself asking..."
						btnText="View all FAQ"
						clickUrl="/frequently-asked-questions"
					/>
					<FaqBlock questions={questions}/>
				</div>
			</div>
			<JobInquiryModal modalVisible={modalVisible} setModalVisible={setModalVisible}/>
		</div>
	);
};

export default withSeo(Veterinarian, state => state.veterinarianPage, 'veterinarianPage', 'careers/become-a-veterinarian');